import UnivarietyLogo from '../../../../styles/images/logo.png';
import '../../../../styles/css/BASstyles.css';
import PaceForm from './PaceForm';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { convertDomainArrayToMap, getDomainData } from '../../../../library/Core/SmartFunctions';
import { axiosClient } from '../../../../library/Service/axiosClient';

const PaceFormParentSelfBooking = () => {
      const {  userId  } = useParams();
    
       const [domain, setDomain] = useState<Map<string, any>>(new Map());
       const [data, setData] = useState<any>(null);

       useEffect(() => {
          const loadInitialData = async () => {
            const rawDomain = await getDomainData();
            const domainMap = rawDomain instanceof Map ? rawDomain : convertDomainArrayToMap(rawDomain);
            setDomain(domainMap);

            if (userId) {
             const response = await axiosClient().post(`${process.env.REACT_APP_BAS_API}/bas/get-studentDetails-by-uuid`, {
              userId: userId,
             });
              const student = response.data?.data?.[0];            
              setData(student);
            }
          };
          loadInitialData();
        }, [userId]);


  return (
    <div className="bg-blue basUI">
      <div className="container container-wrap">
        <header className="mt-md-5 mt-4 bg-transparent">
          <img src={UnivarietyLogo} className='img-fluid' width="180" alt="Univariety Logo" />
        </header>

        <div className="row pb-4">
          {/* <!-- left pane start --> */}
            <div className="col-lg-5 pr-5 mt-md-5 pt-md-3 mt-5 d-flex flex-column justify-content-between">
                <div className="sticky-top pt-4">
                    <h1 className="font-700 font-30 head-line">Talk To Us!</h1>
                    <p className="font-15  pr-5">Your expectations for your child's career. Let's start with basic details on Course, College & Country of Interest.</p>

                    <a className="d-none-desktop mt-2 font-14" data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
                        <u className="read">Read More</u>
                    </a>

                    <div className="d-none-mobile" id="collapseExample">
                        <img src="https://www.univariety.xyz/prototype/bas/images/talktous.svg" className="mt-4 mb-4" />
                    </div>
                </div>

               <div className="mt-5 pt-5 font-12 d-none-mobile">
                  <p className="mb-0 footertxt">
                    <b>International Educational Gateway Pvt. Ltd. © {new Date().getFullYear()}</b>
                  </p>
                  <span>All Rights Reserved. Univariety</span>
                </div>
            </div>
            {/* <!-- left pane end--> */}

          {/* <!-- right pane --> */}
          <div className="col-lg-7 mb-lg-0 pb-lg-0 mb-0 pb-5 mt-5 bg-blue-mobile">
            <PaceForm
            userId={userId}
            isSelfBooking={true}
            state={{ domain, data: { programLevel: data?.program_level } }}
            model={{ id: userId, firstName: data?.firstName, lastName:data?.lastName }}
            />    
          </div>
        </div>

        {/* Footer for mobile */}
        <div className="d-none-desktop bg-blue-mobile text-white text-center py-3 font-300">
          <p className="mb-0"><b>International Educational Gateway Pvt. Ltd. © 2021</b></p>
          <span>All Rights Reserved . Univariety</span>
        </div>
      </div>
    </div>
  );
};

export default PaceFormParentSelfBooking;
